import React from 'react';
import PropTypes from 'prop-types';
import { FormattedHTMLMessage, FormattedMessage } from 'react-intl';
import Button from 'components/common/Button';

const propTypes = {
  email: PropTypes.string.isRequired,
  isLoading: PropTypes.bool,
};

const ThankYou = (props) => {
  const { isLoading } = props;
  return (
    <div className="loan-form__step">
      <p className="txt-center">
        <span className="icon icon--low icon--heart" />
      </p>
      <h1 className="loan-form__step-title loan-form__step-title--small">
        <FormattedHTMLMessage id="migration.thank_you.title" />
      </h1>
      <div className="loan-form__step-body">
        <div className="thank-you">
          <h3 className="thank-you__text thank-you__text--primary txt-center">
            <FormattedHTMLMessage
              id="migration.thank_you.text"
              values={{ email: props.email }}
            />
          </h3>
        </div>
        <div className="txt-center">
          <Button
            btnSize="wide"
            isLoading={isLoading}
            disabled={isLoading}
          >
            <FormattedMessage id="migration.thank_you.submit" />
          </Button>
        </div>
      </div>
    </div>
  );
};

ThankYou.propTypes = propTypes;

export default ThankYou;
